import { Injectable } from '@angular/core';
import { GeoPoint } from 'firebase/firestore';
import { Polygon, FeatureCollection } from 'geojson';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class EditMapHistoryServiceService {

  original: FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.Point>| any | null = null;
  undoSteps: FeatureCollection<Polygon>[] | GeoJSON.FeatureCollection<GeoJSON.Point>[] | any[] = [];
  redoSteps: FeatureCollection<Polygon>[] | GeoJSON.FeatureCollection<GeoJSON.Point>[] | any[] = [];
  undoList:BehaviorSubject<FeatureCollection<Polygon>[] | GeoJSON.FeatureCollection<GeoJSON.Point>[]>  = new BehaviorSubject<FeatureCollection<Polygon>[] | GeoJSON.FeatureCollection<GeoJSON.Point>[]>([])

  start(features: GeoJSON.FeatureCollection<GeoJSON.Point | GeoJSON.Polygon | GeoJSON.MultiLineString>  | FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.MultiLineString> | GeoJSON.Feature<GeoJSON.Point>) {
    if (!this.original) {
      this.original = structuredClone(features);
      this.undoSteps.push(structuredClone(features));
      this.redoSteps = [];
      this.undoList.next(this.undoSteps)
    }

  }

  pushState(features: GeoJSON.FeatureCollection<GeoJSON.Point | GeoJSON.Polygon | GeoJSON.MultiLineString>  ) { // | FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.Point>
    if (!this.original) this.start(features);
    this.undoSteps.push(structuredClone(features));
    this.undoList.next(this.undoSteps)
    this.redoSteps = [];
  }

  undo(): FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.Point | GeoJSON.Polygon | GeoJSON.MultiLineString>  | null { //GeoJSON.Feature<GeoJSON.Point>
    if (!this.original) return null;

    // return original features on last undo
    if (this.undoSteps.length <= 1)
      return structuredClone(this.original);

    const current = this.undoSteps.pop()!;
    this.redoSteps.push(current);

    return structuredClone(this.undoSteps[this.undoSteps.length - 1]);
  }

  redo(): FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.Point | GeoJSON.Polygon | GeoJSON.MultiLineString>  | null { // FeatureCollection<Polygon> | GeoJSON.FeatureCollection<GeoJSON.Point> | GeoJSON.Feature<GeoJSON.Point> | null 
    if (this.redoSteps.length === 0) return null;

    const feature = this.redoSteps.pop()!;
    this.undoSteps.push(feature);
    this.undoList.next(this.undoSteps)

    return structuredClone(feature);
  }

  reset() {
    this.original = null;
    this.undoSteps = [];
    this.undoList.next(this.undoSteps)
    this.redoSteps = [];
  }

  get checkUndo() { return this.undoSteps.length > 0; }
  get checkRedo() { return this.redoSteps.length > 0; }

}